import axios from "axios";
import * as actionType from "../../../constant/actionType";
// import { fetchData,fetchDataSuccess, fetchDataError } from "../../redux/classes/client-portal/clientCsvSlice";
export const SubmitExistingDocToClient = (ApiData) => async (dispatch) => {
      try {
        const response = await axios({
          method: 'post',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
          },
          url: `${actionType.environment_url}/api/admin/provider/SubmitExistingDocToClient`,
        });
        return response.data
      } catch (error) {
        return error.message
      }
    }
    export const SubmitExistingDocToClientP = (ApiData) => async (dispatch) => {
      const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
      
      try {
        const response = await axios({
          method: 'post',
          data: ApiData,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
            organisationid: storedData?.organisation_id,
          },
          url: `${actionType.environment_url}/api/provider/SubmitExistingDocToClient`,
        });
        return response.data
      } catch (error) {
        return error.message
      }
    }